import React from "react";
import { Link, Grid } from "@mui/material";
import { FormikConsumer } from "formik";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { Button } from "components/haven-design/buttons";
import { loginStyles, loginAuthColumnSx } from "./styles";
import styles from "./Login.module.css";
import TimerButton from "./timer-button";

const LoginFormMobile: React.FC<{sendCode: () => void; resetAwaitingCode: () => void;}> =
({ sendCode, resetAwaitingCode }) => (
  <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center">
    <Grid size={{ xs: 12 }} sx={loginAuthColumnSx}>
      <InputWithErrorLabel
        slotProps={{
          htmlInput: {
            minLength: 4,
            maxLength: 4,
            pattern: "[0-9]*",
            inputMode: "numeric",
          },
        }}
        autoFocus
        label="Login Code"
        title="4 digit numeric code that we texted you"
        name="code"
        id="code"
        type="text"
        style={loginStyles.loginInput}
      ></InputWithErrorLabel>
      <TimerButton sendCode={sendCode} />
    </Grid>
    <Grid size={{ xs: 12 }} sx={loginAuthColumnSx}>
      <FormikConsumer>
        {({ isSubmitting }) => (
          <Button
            id="login-btn"
            type="submit"
            color="primary"
            size="L"
            fullWidth
            className={styles.loginButton}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Loading..." : "Verify & Log In"}
          </Button>
        )}
      </FormikConsumer>
    </Grid>
    <Grid>
      <Link component="button" variant="body2" onClick={resetAwaitingCode}>
        Go back
      </Link>
    </Grid>
  </Grid>
);

export default LoginFormMobile;
